import styled from "styled-components"

const PlanetImage = styled.img`
  filter: ${props => (props.blocked ? "brightness(35%)" : "none")};
`

export default PlanetImage
